module.exports = __webpack_public_path__ + "img/le_monde.2cb1175.png";